// extracted by mini-css-extract-plugin
module.exports = {"NutritionalEditor":"NutritionalEditor_NutritionalEditor__3rpz2","Saver":"NutritionalEditor_Saver__3Djpf","Hidden":"NutritionalEditor_Hidden__2bVD5"};